export default "__VITE_ASSET__CiuIPE47__"